<template>
  <div style="margin: 10px;width: 100%;">
    <div>
      <query-gather :is-add="false" :is-input="true" :is-query="true" :is-reset="true" @qgQueryDeal="qgQuery"
                    @qgResetDeal="resetDmDataDeal"
                    :cur-input-tip="'搜索相关资料'" style="background-color: #FFFFFF;position:relative;">
        <div slot="left" class="dmLeft">
          资料库
        </div>
        <div slot="right">
          <div v-if="false">
            <button @click="plcz" class="queryButton dmBtn" :style="{right:plczFlag?'26vh':'14vh'}">
              {{ plczText }}
            </button>
            <button v-if="plczFlag" class="queryButton dmBtn" @click="plxz">批量下载</button>
          </div>

          <button class="queryButton dmBtn" @click="addData" style="right:2vh;">
            <img src="../../../public/icon/sctb.png" style="margin-right: 5px"/>上传
          </button>
        </div>
      </query-gather>
    </div>
    <div style="margin-top: 10px;">
      <el-container style="background-color:#f8f9fd;">
        <div style="height: 78vh;">
          <el-aside width="15vw" style="height: 100%;overflow:auto;">
            <el-tree highlight-current :data="dmMcOptions" node-key="id" :expand-on-click-node="false"
                     :props="defaultProps" @node-click="handleNodeClick" ref="docTree"
                     accordion style="padding: 20px 20px 10px 30px;height: 75vh;">
              <span class="custom-tree-node" slot-scope="{node,data}">
                  <span class="text-wrapper" @mouseenter="visibilityChange($event)">{{ node.label }}</span>
                  <el-tooltip class="item" effect="light" placement="right">
                      <i v-if="node.level==2" class="el-icon-question"
                         style="position: absolute; right: 5px;font-size: 14px;vertical-align: middle;color: #606266 !important;"></i>
                      <div slot="content" style="width: 200px;">
                          {{ data.description }}
                      </div>
                  </el-tooltip>
              </span>
            </el-tree>
          </el-aside>
        </div>
        <el-main style="background-color:#f8f9fd;width: 10vw;padding-top: 0px;padding-bottom: 0px">
          <div class="doc-list">
            <el-scrollbar style="height: 78vh">
              <el-table :data="docList" height="78vh" :show-header="false" @row-click="(row)=>loadFromUrl(row)"
                        @selection-change="handleSelectionChange"
                        :cell-style="{border:0 + 'px' }" ref="multipleTable"
                        element-loading-text="拼命加载中"
                        element-loading-spinner="el-icon-loading"
                        v-loading="loading"
                        highlight-current-row>
                <el-table-column
                    v-if="plczFlag"
                    type="selection"
                >
                </el-table-column>
                <el-table-column
                    prop="type"
                    style="border:none"
                    width="50"
                >
                  <template slot-scope="scope">
                    <div style="display: flex;align-self: baseline">
                      <img v-if="scope.row.type === 'doc' || scope.row.type === 'docx'"
                           src="../../../public/icon/word.svg" class="table-image"/>
                      <img v-else-if="scope.row.type === 'xls' || scope.row.type === 'xlsx'"
                           src="../../../public/icon/excel.svg" class="table-image"/>
                      <img v-else-if="scope.row.type === 'zip' || scope.row.type === 'rar'"
                           src="../../../public/icon/zip.png" class="table-image"/>
                      <img v-else-if="scope.row.type === 'png' || scope.row.type === 'jpg'"
                           src="../../../public/icon/picture.png" class="table-image"/>
                      <img v-else-if="scope.row.type === 'pdf'" src="../../../public/icon/pdf.svg" class="table-image"/>
                      <span style="margin-left: 10px;padding-top: 0.3rem">
                        <div
                            style="text-overflow: ellipsis;white-space: nowrap;overflow: hidden;max-width: 400px "
                            @mouseenter="visibilityChange($event)">{{ scope.row.name }}
                        </div>
                      </span>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="dbnm" align="left"></el-table-column>
                <el-table-column width="60">
                  <template slot-scope="scope">
                    <el-dropdown>
                                    <span class="el-dropdown-link">
                                    <i class="el-icon-more "></i>
                                    </span>
                      <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item>
                          <div @click="downloadTz(scope.row)" style="display: flex">
                            <i class="el-icon-xiazai" style="width: 22px;height: 16px"></i>
                            <span
                                style="margin-top: 2px;margin-left:-2px;font-size: 14px;font-weight: normal;font-stretch: normal;letter-spacing: 0px;color: #707070;">下载</span>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div @click="cmm(scope.row)" style="display: flex">
                            <i class="el-icon-chongmm" style="width: 20px;height: 20px"></i>
                            <span
                                style="margin-top: 5px;font-size: 14px;font-weight: normal;font-stretch: normal;letter-spacing: 0px;color: #707070;">重命名</span>
                          </div>
                        </el-dropdown-item>
                        <el-dropdown-item>
                          <div @click="delFile(scope.row)" style="display: flex">
                            <i class="el-icon-shanchu" style="width: 20px;height: 20px"></i>
                            <span
                                style="margin-top: 5px;font-size: 14px;font-weight: normal;font-stretch: normal;letter-spacing: 0px;color: #ea3d31;">删除</span>
                          </div>
                        </el-dropdown-item>
                      </el-dropdown-menu>
                    </el-dropdown>
                  </template>
                </el-table-column>
              </el-table>
            </el-scrollbar>
          </div>
        </el-main>
        <el-aside style="background-color:#f8f9fd;" width="35vw">
          <div style="background-color: #e9eff4;height: 6vh;position: relative">
            <i class="el-icon-full-screen" @click="openPpt"
               style="position: absolute;transform: translate(-50%,-50%);top: 50%;right: 5%;cursor: pointer"></i>
          </div>
          <iframe ref="frame" :src="fileUrl" style="min-height: calc(100vh - 264px); width:100%; border: 0"/>
        </el-aside>
        <data-dialog :dialog-title="dmDialog.title" :is-visible="dmDialog.dmFormVisible" :is-read="isRead"
                     @dgVerifyDeal="dgVerifyDeal('dmDialog','upFrom')" ref="dmDialog" @dgConfirmDeal="dgConfirmDeal"
                     @dgCancelDeal="dgCancelDeal">
          <div slot="dialogFrom">
            <el-form ref="upFrom" :model="dmDialog.data" :rules="rules" label-position="left" label-width="90px"
                     v-loading="uploading">
              <el-row>
                <el-col :span="13">
                  <el-form-item label="资料目录" prop="code">
                    <el-select
                        v-model="dmDialog.data['code']"
                        size="large"
                        placeholder="请选择资料类型"
                        style="width: 100%;"
                    >
                      <el-option
                          v-for="item in dmMcOptions"
                          :key="item.code"
                          :label="item.name"
                          :value="item.code"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="上传文档" prop="fileList">
                    <el-upload
                        ref="fileUpload"
                        action="#"
                        multiple
                        :auto-upload="true"
                        :file-list="dmDialog.data.file"
                        :show-file-list="false"
                        :before-upload="before_upload"
                        :http-request="fileUpload"
                        :on-remove="fileRemove"
                        :accept="'.doc, .docx, .xlsx, .xls, .pdf, .ppt, .pptx, .zip, .rar,.jpg, .png'"
                    >
                      <el-button size="small" type="primary">选择文件上传</el-button>
                    </el-upload>
                    <div class="table-container">
                      <el-table :data="dmDialog.data.fileList" style="width: 100%;">
                        <el-table-column prop="rname" :show-overflow-tooltip="true" label="名称">
                          <template slot-scope="scope">
                            <i style="color:#409EFF" class=" el-icon-s-order"/>{{ scope.row.rname }}
                          </template>
                        </el-table-column>
                        <el-table-column prop="progress" label="是否成功" width="300">
                          <template slot-scope="scope">
                            <el-progress :percentage="scope.row.progress"/>
                          </template>
                        </el-table-column>
                        <el-table-column width="120" prop="filesize" label="大小"/>
                        <el-table-column width="180" :show-overflow-tooltip="true" label="功能">
                          <template slot-scope="scope">
                            <el-button type="primary" size="mini" @click="removeFile(scope.row)">删除</el-button>
                          </template>
                        </el-table-column>
                      </el-table>
                    </div>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </data-dialog>
        <data-dialog :dialog-title="'重命名'" :is-visible="cmmVisible" :is-read="false"
                     @dgVerifyDeal="dgVerifyDeal('rnDialog','rnForm')"
                     ref="rnDialog" @dgConfirmDeal="dgReNameConfirmDeal"
                     :is-own-style="true" :dg-style="dgSmallStyle"
                     @dgCancelDeal="dgCancelDeal">
          <div slot="dialogFrom">
            <el-form ref="rnForm" :rules="reNameRules" :model="fileItem" label-width="80px">
              <el-row style="margin: 2vh;">
                <el-col :span="12">
                  <el-form-item label="文件名" prop="dbnm">
                    <el-input v-model="fileItem.dbnm" style="width: 100%;" clearable></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </data-dialog>

      </el-container>
    </div>
  </div>
</template>
<script>

/**
 * @Author: ygh
 * @Date: 2024/3/11 10:40
 * @Description:资料库页面
 */
import {Base64} from "js-base64";
import QueryGather from "../../components/buttonGather/queryGather";
import DataDialog from "../../components/tableGather/dataDialog";
import {fileHost} from "../../utils/config";

export default {
  name: 'datum',
  components: {DataDialog, QueryGather,},
  data() {
    let validateMcLen = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback();
      } else {
        if (value.length > 30) {
          return callback(new Error("长度不能超过30个字符"));
        } else {
          return callback();
        }
      }
    };

    return {
      curInputValue: '',
      reNameRules: {
        dbnm: [
          {required: true, message: '文件名不能为空', trigger: 'blur'},
          {validator: validateMcLen, trigger: 'blur'},
        ],
      },
      rules: {
        code: [
          {required: true, message: '资料类型不能为空', trigger: 'blur'},
        ],
        fileList: [
          {required: true, message: '文件列表不能为空', trigger: 'blur'},
        ]
      },
      dgSmallStyle: {
        height: '30%',
        marginTop: '0',
        width: '45vw',
      },
      dmDialog: {
        title: "",
        dmFormVisible: false,
        data: {
          fileList: [],
        },
      },
      dmParams: {
        total: 0,
        size: 10,
        current: 1,
        dbtype: '',
      },
      isRead: false,
      uploading: false,
      uploadPercentage: 0,
      dmMcOptions: [],
      fileUrl: '',
      formSearch: {
        companyId: '',
        name: '',
        pageSize: 25, // 每页数据的量
        currentPage: 1, // 当前页索引
        totalSize: 0, //总数量
        currentSkipCount: 0, //当前显示
      },
      cmmVisible: false,
      treeData: [],
      mrzk: [],
      filename: '',
      fileItem: {},
      optionDisplay: false,
      docMrzk: [75],
      currentKey: '',
      currentCode: '',
      stcdKeyPop: '',
      xzqhlist: [],
      url: 'https://flyfish.group/%E6%95%B0%E6%8D%AE%E4%B8%AD%E5%8F%B0%E7%AC%94%E8%AE%B0(1).docx',
      isCollapse: true,
      judgeTip: false,
      docTypeData: [],
      defaultProps: {
        children: 'child',
        label: 'name'
      },
      loading: false,
      src: '',
      items: [{
        imageUrl: '../../../public/icon/banner.png'
      }],
      isFirst: true, // 是否第一次加载
      plczFlag: false,
      plczText: '批量操作',
      multipleSelection: [],
      docList: [],
      files: [],
      //预览txt
      content: '',
      dop: {
        companyName: '',
        companyId: '',
        current: '',
        visible: false,
        title: "添加台账",
      },
    }
  },
  watch: {
    "$store.state.head.skCd"() {
      this.resetDmDataDeal();
    }
  },
  mounted() {
    this.initDatumData();
  },
  methods: {
    initDatumData() {
      this.clearIframe();
      this.getDmOptions();
    },
    clearIframe() {
      this.fileUrl = '';
    },
    before_upload(file) {
      this.uploading = true;
      // 截取上传文件的后缀名
      let fileType = file.name.substring(file.name.lastIndexOf(".") + 1);
      const fileList = {}
      for (const key in file) {
        fileList[key] = file[key]
      }
      // 判断多个
      if (!["pdf", "doc", "docx", "xls", "xlsx", "pptx", "pptx", "zip", "rar", "jpg", "png"].includes(fileType)) {
        this.$message({
          message: "只能上传word/excel/pdf/zip/rar/jpg/png文件",
          type: 'error',
          duration: 1000, //显示时间 <=0：永久显示,1000：1s
        });
        return false;
      }
    },
    //上传文件
    fileUpload(obj) {
      // 上传文件获取路径
      let formData = new FormData(); //参数的格式是formData格式的
      // 追加文件
      formData.append(`file`, obj.file);
      let filepath = '';
      this.request.post('/rm-sfile/v1/upload/file', formData, {
        onUploadProgress: progressEvent => {
          const complete = parseInt((progressEvent.loaded / progressEvent.total) * 100);
          this.uploadPercentage = complete;
          obj.onProgress({progress: complete});
        },
        params: formData, // 你可能需要将其他参数添加到 params 中
        headers: {
          'Content-Type': 'multipart/form-data' // 设置请求头，指示请求是一个多部分请求
        }
      }).then(res => {
        filepath = fileHost + res.data['path'];
        this.dmDialog.data.fileList.push({
          ...res.data,
          progress: this.uploadPercentage,
          index: this.dmDialog.data.fileList.length + 1
        });
        this.uploading = false;
      }).catch(error => {
        // 处理上传失败的情况
      });
    },
    removeFile(row) {
      let targetIndex = this.dmDialog.data.fileList.findIndex((itemTemp) => itemTemp === row);
      if (targetIndex !== -1) {
        this.dmDialog.data.fileList.splice(targetIndex, 1);
      }
    },
    // 移除文件处理
    fileRemove(file, fileList) {
      this.dmDialog.data.fileList = fileList;
    },
    dgVerifyDeal(dgRef, frRef) {
      this.$refs[frRef].validate((valid) => {
        if (valid) {
          this.$refs[dgRef].isShowPop(true);
        } else {
          this.$refs[dgRef].isShowPop(false);
        }
      });
    },
    dgCancelDeal() {
      if (this.dmDialog.dmFormVisible) {
        this.dmDialog.dmFormVisible = false;
        this.$refs['upFrom'].clearValidate();
      }
      if (this.cmmVisible) {
        this.cmmVisible = false;
        this.$refs.rnForm.clearValidate();
      }
      // console.log("======dgCancelDeal======");
    },
    dgConfirmDeal() {
      this.isRead = false;
      this.$refs.upFrom.clearValidate();
      this.addDmItemDeal();
      // console.log("======dgConfirmDeal==d====");
    },
    dgReNameConfirmDeal() {
      this.cmmVisible = false;
      this.updateDmItemDeal();
    },
    updateDmItemDeal() {
      this.request.put('/rm-bdb/v1', this.fileItem).then(res => {
        if (res.ok) {
          this.dmParams.dbtype = this.fileItem.dbtype;
          this.getDmItemByLx();
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    addDmItemDeal() {
      let itemList = [];
      for (let i = 0; i < this.dmDialog.data.fileList.length; i++) {
        let params = {
          dbtype: this.dmDialog.data['code'],
          dbnm: this.dmDialog.data.fileList[i]['rname'],
          dbpath: this.dmDialog.data.fileList[i]['path'],
        }
        itemList.push(params);
      }
      if (itemList.length > 0) {//有文件才上传
        this.request.post('/rm-bdb/v1', itemList).then(res => {
          if (res.ok) {
            this.$message.success('添加资料文件成功');
            this.dmParams.dbtype = this.dmDialog.data['code'];
            this.dmDialog.dmFormVisible = false;
            this.dmDialog.data.fileList = [];
            this.getDmItemByLx();//通过类型获取资料
          } else {
            this.$message.error(res.error.message);
          }
        });
      }
    },
    getDmItemByLx() {
      this.loading = true;
      let pStr = 'dbtype=' + this.dmParams.dbtype;
      if (this.curInputValue !== '') {
        pStr += '&dbnm=' + this.curInputValue;
      }
      this.request.get('/rm-bdb/v1/list?' + pStr).then(res => {
        if (res.ok) {
          if (res.data != null) {
            this.docList = [];
            for (let i = 0; i < res.data.length; i++) {
              this.docList.push({
                ...res.data[i],
                'type': res.data[i]['dbpath'].split('.')[1],
              })
            }
            // console.log(res, '===getDmItemByLx===', this.docList);
          } else {
            this.$message.info("获取资料数据为空");
          }
        } else {
          this.$message.error(res.error.message);
        }
        this.loading = false;
      });
    },
    getDmOptions() {
      this.request.get('rm-sdictionary/v1/query/12').then(res => {
        if (res.ok) {
          if (res.data != null) {
            this.dmMcOptions = [];
            for (let i = 0; i < res.data.length; i++) {
              this.dmMcOptions.push({
                "id": res.data[i]['id'],
                "name": res.data[i]['name'],
                "code": res.data[i]['code'],
                "description": res.data[i]['comment'],
                "child": null,
              })
            }
            this.$nextTick(() => {
              this.$refs.docTree.setCurrentKey(res.data[0]['id']);
              this.dmParams.dbtype = res.data[0]['code'];
              this.currentCode = res.data[0]['code'];
              this.getDmItemByLx();
            })
            // console.log(res, '===getDmOptions===', this.dmMcOptions, this.docMrzk);
          } else {
            this.$message.info("获取资料类型数据为空");
          }
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    getTableData() {
      const param = {
        name: this.formSearch.name,
        ssflid: this.currentKey,
        companyId: '',
        size: this.formSearch.pageSize,
        current: this.formSearch.currentPage
      }
      this.request.post("/doc-file/v1/query/pageList-enter", param).then((res) => {
        if (res.ok) {
          this.docList = res.data.records;
          this.$refs.multipleTable.toggleAllSelection()

        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    saveclose() {
      this.dop.visible = false;
      this.getTableData()
    },
    cz() {
      this.formSearch.name = '';
      this.getTableData();
    },
    delFile(item) {
      this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.request.delete("/rm-bdb/v1/" + item.id).then((res) => {
          if (res.ok) {
            this.$message.success('删除成功！');
            this.clearIframe();
            this.dmParams.dbtype = item.dbtype;
            this.getDmItemByLx();
          } else {
            this.$message.error(res.error);
          }
        });
      });

    },
    openPpt() {
      window.open(this.fileUrl);
    },
    scrollLoad() {
      if (this.isFirst) {
        // this.getTableData();
      } else {
        // this.$message.success('加载下一页');
        this.formSearch.currentPage = this.formSearch.currentPage + 1;
        this.formSearch.currentSkipCount =
            (this.formSearch.currentPage - 1) * this.formSearch.pageSize;
        this.getTableData();
      }
    },
    handleNodeClick(data) {
      this.currentKey = data.id;
      this.currentCode = data.code;
      // this.dop.current = this.currentKey;
      this.dmParams.dbtype = data['code'];
      this.clearIframe();
      this.getDmItemByLx();
    },
    cmm(item) {
      this.cmmVisible = true;
      this.fileItem = {...item};
    },
    cmmFf() {
      const data = {
        filename: this.fileItem.name,
        id: this.fileItem.id,
      }
      this.request.put("/doc-file/v1", data).then((res) => {
        if (res.ok) {
          this.$message.success('修改成功！');
          this.cmmVisible = false;
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    getTreeData() {
      const param = {paramStr: '', type: '2'};
      this.request.get("/sys-admindiv/v1/tree", {params: param}).then((res) => {
        if (res.ok) {
          this.treeData = res.data;
          if (this.treeData.length > 0) {
            this.mrzk.push(this.treeData[0].nodeId);
          }
        } else {
          this.$message.error(res.error);
        }
      });
    },
    downloadTz(item) {
      const fileInfo = {
        path: item.dbpath,
        fileName: item.dbnm + '.' + item.type,
      }
      this.request.get("/rm-sfile/v1/file/download", {params: fileInfo, responseType: "blob"}).then((res) => {
        try {
          let blob = new Blob([res.data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'});
          const a = document.createElement("a");
          a.href = URL.createObjectURL(blob);
          // 这里填保存成的文件名
          a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
          a.click();
          URL.revokeObjectURL(a.href);
          return;
        } catch (error) {
          const reader = new FileReader();
          reader.readAsText(res.data, 'utf-8');
          let _this = this;
          reader.onload = function () {
            const msg = JSON.parse(reader.result);
            if (!msg.ok) {
              _this.$message.error(msg.error.message);
            }
          }
        }
      });
    },
    getDocTypeTree() {
      this.request.post("/doc-type/v1/getTree").then((res) => {
        if (res.ok) {
          this.docTypeData = res.data;
          if (this.docTypeData.length > 0) {
            this.docMrzk.push(this.docTypeData[0].child[0].id);
            this.$nextTick(() => {
              this.currentKey = this.docTypeData[0].child[0].id;
              this.dop.current = this.currentKey;
              this.$refs.docTree.setCurrentKey(this.docTypeData[0].child[0].id);//默认选中第一条
              this.getTableData();
            })
          }
        } else {
          this.$message.error(res.error.message);
        }
      });
    },
    isImageFile(filePath) {
      // 匹配字符串中最后四位是否为图片后缀名
      let match = filePath.match(/\.(jpg|jpeg|png|gif)$/i); // 不区分大小写
      return match !== null;
    },
    // 从url加载
    loadFromUrl(val) {
      let url = "";
      console.log('val',val)
      if (this.isImageFile(val.dbpath)) {
        url = fileHost + val.dbpath;
        console.log('fileHost',fileHost)
          console.log('val',val.dbpath)
      } else {
        url = "http://10.168.103.238:9503/iirms/private/" + val.dbpath;
      }
      //url = 'https://10.168.103.238:9503/iirms/private/docx/20240416/f2bf5e9fa93b42ae.docx'
      this.fileUrl = 'https://wjyl.hyicloud.com/onlinePreview?url=' + encodeURIComponent(Base64.encode(url));
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    visibilityChange(e) {
      let ev = e.target;
      if (ev.offsetWidth + 300 > ev.offsetParent.offsetWidth) {
        this.judgeTip = false;
      } else {
        this.judgeTip = true;
      }
    },
    resetDmDataDeal() {
      this.curInputValue = '';
      this.dmParams.dbtype = this.currentCode;
      this.clearIframe();
      this.getDmItemByLx();
    },
    qgQuery(params) {
      this.curInputValue = params.curInputValue;
      this.clearIframe();
      this.getDmItemByLx();
    },
    addData() {
      this.dmDialog.title = '上传资料';
      this.dmDialog.data['code'] = this.currentCode;
      this.dmDialog.dmFormVisible = true;
    },
    plcz() {
      this.$refs.multipleTable.clearSelection();
      this.plczFlag = !this.plczFlag;
      if (this.plczFlag) {
        this.plczText = "取消操作";
        this.$refs.multipleTable.toggleAllSelection()
      } else {
        this.plczText = "批量操作";
      }
    },
    plxz() {
      let ids = '';
      this.multipleSelection.forEach(item => {
        ids = ids + item.id + ','
      });
      ids = ids.slice(0, -1);
      if (this.multipleSelection.length <= 0) {
        this.$message.info("请至少选中一个文件进行下载！");
      } else {
        this.request({
          url: '/rm-sfile/v1/file/batch/download?ids=' + ids,
          method: 'get',
          headers: {},
          responseType: 'blob',
        }).then((res) => {
          try {
            let blob = new Blob([res.data], {type: "application/zip"});
            const a = document.createElement("a");
            a.href = URL.createObjectURL(blob);
            a.download = decodeURI(res.headers["content-disposition"].split(";")[1].split("=")[1]);
            a.click();
            URL.revokeObjectURL(a.href);
            return;

          } catch (error) {
            const reader = new FileReader();
            reader.readAsText(res.data, 'utf-8');
            let _this = this;
            reader.onload = function () {
              const msg = JSON.parse(reader.result);
              if (!msg.ok) {
                _this.$message.error(msg.error.message);
              }
            }
          }
        });
      }
    },
  }
}
</script>

<style scoped>
.dmBtn {
  width: 100px;
  height: 35px;
  line-height: 35px;
  border: 0;
  cursor: pointer;
  position: absolute;
  right: 14vh;
  top: 1.4vh;
}

.dmLeft {
  width: 15vh;
  color: #4B4B4B;
  font-family: PingFang SC;
  font-size: 1.8rem;
  font-weight: bold;
  font-stretch: normal;
  letter-spacing: 0rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/deep/ .el-table tr {
  cursor: pointer;
}

/* /deep/ .el-table__body tr.current-row>td{
    background-color: #d0dde8 !important;
    color: #323232;
} */
::v-deep .el-table__body tr.current-row > td.el-table__cell {
  background-color: #D0DDE8;
  color: #323232;
}

.mainFont {
  /*position: fixed;*/
  top: calc(100vh - 200px);
  font-family: PingFang SC;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  line-height: 22px;
  letter-spacing: 0px;
  color: #1d1d1d;
}

/deep/ .el-menu {
  border-right: solid 0px #e6e6e6;
}

.doc-list {
  display: flex;
  flex-direction: column;
}

/deep/ .el-table__row > td {
  border: none;
}

/deep/ .el-table::before {
  height: 0px;
}

.table-image {
  width: 28px; /* 根据需要设置图片的尺寸 */
  margin-right: 5px; /* 根据需要设置图片与文字之间的间距 */
  /*margin-top: 5px; !* 根据需要设置图片与文字之间的间距 *!*/
}

/deep/ .el-card__body, .el-main {
  padding: 5px;
}

.el-menu-item.is-active {
  background-color: #3b87f7 !important;
}

/** 树父级字体样式 **/
/deep/ .el-tree > .el-tree-node > .el-tree-node__content > .custom-tree-node {
  font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei", "HanHei SC", "Helvetica Neue", "Open Sans", Arial, "Hiragino Sans GB", 微软雅黑, STHeiti, "WenQuanYi Micro Hei", SimSun, sans-serif, HYWenHei-GEW !important;;
  font-size: 15px;
  font-weight: 700;
  font-stretch: normal;
  line-height: 22px;
  letter-spacing: 0px;
  /*color: #000;*/
}

/** 树子级字体样式 **/
/deep/ .el-tree > .el-tree-node > .el-tree-node__children > .el-tree-node > .el-tree-node__content > .custom-tree-node {
  font-family: "PingFang SC", "Lantinghei SC", "Microsoft YaHei", "HanHei SC", "Helvetica Neue", "Open Sans", Arial, "Hiragino Sans GB", 微软雅黑, STHeiti, "WenQuanYi Micro Hei", SimSun, sans-serif, HYWenHei-GEW !important;;
  font-size: 14px;
  font-weight: normal;
  font-stretch: normal;
  line-height: 20px;
  letter-spacing: 0px;
  /*color: #323232;*/
}

/** 树父级样式 **/
/deep/ .el-tree > .el-tree-node > .el-tree-node__content {
  height: 45px;
}

/** 树子级样式 **/
/deep/ .el-tree-node.is-expanded.is-focusable > .el-tree-node__children > .el-tree-node > .el-tree-node__content {
  height: 40px;
}

/deep/ .el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #619FFC;
  color: #fdfdfd;
  font-weight: bold;
}


.custom-tree-node {
  text-align: left;
  /* width: calc(100% - 3px); */
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  min-width: auto;
  padding: 4px 26px 4px 2px;
  border-radius: 4px;
}

* {
  scrollbar-width: none;
}

::-webkit-scrollbar {
  display: none;
}

::v-deep .el-scrollbar__wrap {
  overflow-x: hidden !important;
  overflow-y: auto;
}

::v-deep .el-scrollbar__bar.is-horizontal {
  /* height: 100%; */
  height: 0;
}

::v-deep .el-scrollbar__bar.is-vertical {
  width: 0
}


.el-dropdown-link {
  cursor: pointer;
  color: #409EFF;
}

.el-icon-xiazai {
  width: 18px;
  height: 18px;
  margin-top: 10px;
  margin-right: 10px;
  cursor: pointer;
  background: url(../../../public/icon/xz.png);
}

.el-icon-chongmm {
  width: 18px;
  height: 18px;
  margin-top: 10px;
  margin-right: 10px;
  cursor: pointer;
  background: url(../../../public/icon/cmm.png);
}

.el-icon-shanchu {
  width: 18px;
  height: 18px;
  margin-top: 10px;
  margin-right: 10px;
  cursor: pointer;
  background: url(../../../public/icon/sc.png);
}
</style>
